import { HttpAxiosRequest } from '../httpAxiosBase'
import { InterfazUpdateCoordenadas } from '../../pages/grafo/types/types'

export const HttpStages = {
    getEndpoint: (systemCode: number, url = '') => `workflow/${systemCode}/etapas${url}`,

    getStages: (systemCode: number) => HttpAxiosRequest.get(HttpStages.getEndpoint(systemCode)),

    updateCoordinates: (data: InterfazUpdateCoordenadas[], systemCode: number) =>
        HttpAxiosRequest.post(HttpStages.getEndpoint(systemCode, '/coordenadas'), data)
}
